export default __webpack_public_path__ + "static/media/terms.57ca3330.png";